'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import { AutoAwesomeIcon } from '../icons';
import { getPosthog } from '../../lib/posthog-lazy';
import styles from './Assistant.module.css';

// The panel is loaded on the first click: shoppers who never open it pay
// nothing for it.
const AssistantPanel = dynamic(
  () => import('./AssistantPanel').then((m) => ({ default: m.AssistantPanel })),
  { ssr: false },
);

interface AssistantLauncherProps {
  // The admin switch (aceb-api `shop-assistant` setting), read by the layout.
  enabled: boolean;
}

export function AssistantLauncher({ enabled }: AssistantLauncherProps) {
  const t = useTranslations('assistant');
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  if (!enabled) return null;

  const openPanel = () => {
    setOpen(true);
    setMounted(true);
    getPosthog()?.capture('assistant_opened');
  };

  return (
    <>
      {!open && (
        <button
          type="button"
          className={styles.launcher}
          onClick={openPanel}
          aria-label={t('open')}
          aria-haspopup="dialog"
          data-testid="assistant-launcher"
        >
          <AutoAwesomeIcon />
          <span className={styles.launcherLabel}>{t('launcher')}</span>
        </button>
      )}
      {mounted && <AssistantPanel open={open} onClose={() => setOpen(false)} />}
    </>
  );
}
